export const Banks = {
  logos: [
    {
      'value': 'NB_HDFC',
      'icon': 'https://tss-static-images.gumlet.io/icons/payment/hdfc.png',
      'name': 'HDFC'
    },
    {
      'value': 'NB_ICICI',
      'icon': 'https://tss-static-images.gumlet.io/icons/payment/icici.png',
      'name': 'ICICI'
    },
    {
      'value': 'NB_SBI',
      'icon': 'https://tss-static-images.gumlet.io/icons/payment/sbi.png',
      'name': 'SBI'
    },
    {
      'value': 'NB_AXIS',
      'icon': 'https://tss-static-images.gumlet.io/icons/payment/axis.png',
      'name': 'Axis'
    }
  ],
  banks: [
    {
      'name': 'Andhra Bank',
      'acr': 'NB_ANDHRA'
    },
    {
      'name': 'Axis',
      'acr': 'NB_AXIS'
    },
    {
      'name': 'Bank of Baroda',
      'acr': 'NB_BOB'
    },
    {
      'name': 'Bank of India',
      'acr': 'NB_BOI'
    },
    {
      'name': 'Bank of Maharashtra',
      'acr': 'NB_BOM'
    },
    {
      'name': 'Canara Bank',
      'acr': 'NB_CANR'
    },
    {
      'name': 'Deutsche Bank',
      'acr': 'NB_DEUT'
    },
    {
      'name': 'Dhanalakshmi Bank',
      'acr': 'NB_DLS'
    },
    {
      'name': 'HDFC',
      'acr': 'NB_HDFC'
    },
    {
      'name': 'ICICI',
      'acr': 'NB_ICICI'
    },
    {
      'name': 'Indian Overseas Bank',
      'acr': 'NB_IOB'
    },
    {
      'name': 'Lakshmi Vilas Bank',
      'acr': 'NB_LVB'
    },
    {
      'name': 'Saraswat Bank',
      'acr': 'NB_SARASB'
    },
    {
      'name': 'SBI',
      'acr': 'NB_SBI'
    },
    {
      'name': 'South Indian Bank',
      'acr': 'NB_SOIB'
    },
    {
      'name': 'Standard Chartered Bank',
      'acr': 'NB_SCB'
    },
    {
      'name': 'State Bank Of India',
      'acr': 'NB_SBI'
    },
    {
      'name': 'United Bank of India',
      'acr': 'NB_UBI'
    },
    {
      'name': 'Vijaya Bank',
      'acr': 'NB_VJYB'
    },
    {
      'name': 'Yes Bank',
      'acr': 'NB_YESB'
    }
  ]
}

export const CardBrands = [
  {
    name: 'Amex Card',
    regex: /^3[47][0-9]/,
    logo: 'https://tss-static-images.gumlet.io/card-logos/american-express.png'
  },
  {
    name: 'BCGlobal',
    regex: /^(6541|6556)[0-9]/,
    logo: 'https://tss-static-images.gumlet.io/card-logos/pcglobal.png'
  },
  {
    name: 'Carte Blanche Card',
    regex: /^389[0-9]/,
    logo: 'https://tss-static-images.gumlet.io/card-logos/carte-blanche.png'
  },
  {
    name: 'Diners Club Card',
    regex: /^3(?:0[0-5]|[68][0-9])[0-9]/,
    logo: 'https://tss-static-images.gumlet.io/card-logos/diners-club.png'
  },
  {
    name: 'Discover Card',
    regex: /^65[4-9][0-9]|64[4-9][0-9]|6011[0-9]|(622(?:12[6-9]|1[3-9][0-9]|[2-8][0-9][0-9]|9[01][0-9]|92[0-5])[0-9])/,
    logo: 'https://tss-static-images.gumlet.io/card-logos/discover.png'
  },
  {
    name: 'JCB Card',
    regex: /^(?:2131|1800|35\d)\d/,
    logo: 'https://tss-static-images.gumlet.io/card-logos/jcb.png'
  },
  {
    name: 'Maestro Card',
    regex: /^(50|5[6-8]|6304|6759|6761|6763)/,
    logo: 'https://tss-static-images.gumlet.io/card-logos/maestro.png'
  },
  {
    name: 'Mastercard',
    regex: /^(5[1-5][0-9]|2(22[1-9][0-9]|2[3-9][0-9]|[3-6][0-9]|7[0-1][0-9]|720[0-9]))/,
    logo: 'https://tss-static-images.gumlet.io/card-logos/master-card.png'
  },
  {
    name: 'Solo Card',
    regex: /^(6334|6767)[0-9]|(6334|6767)[0-9]|(6334|6767)[0-9]/,
    logo: 'https://tss-static-images.gumlet.io/card-logos/solo.png'
  },
  {
    name: 'Switch Card',
    regex: /^(4903|4905|4911|4936|6333|6759)[0-9]|(4903|4905|4911|4936|6333|6759)[0-9]|(4903|4905|4911|4936|6333|6759)[0-9]|564182[0-9]|564182[0-9]|564182[0-9]|633110[0-9]|633110[0-9]|633110[0-9]/,
    logo: 'https://tss-static-images.gumlet.io/card-logos/switch.png'
  },
  {
    name: 'Union Pay Card',
    regex: /^(62[0-9])/,
    logo: 'https://tss-static-images.gumlet.io/card-logos/unionpay.png'
  },
  {
    name: 'Rupay Debit',
    regex: /^6[0-9]/,
    logo: 'https://tss-static-images.gumlet.io/card-logos/rupay.jpg'
  },
  {
    name: 'Visa Card',
    regex: /^4[0-9](?:[0-9])?/,
    logo: 'https://tss-static-images.gumlet.io/card-logos/visa.png'
  },
  {
    name: 'Visa Electron',
    regex: /^(?:4[0-9](?:[0-9])?|5[1-5][0-9])/,
    logo: 'https://tss-static-images.gumlet.io/card-logos/electron.png'
  }
]

export const Wallets = [
  // {
  //   wallet: 'PHONEPE',
  //   icon: 'https://tss-static-images.gumlet.io/icons/phonepe.png'
  // },
  {
    wallet: 'PAYTM',
    icon: 'https://tss-static-images.gumlet.io/icons/payment/paytm.png',
    name: 'PayTM'
  },
  {
    wallet: 'MOBIKWIK',
    icon: 'https://tss-static-images.gumlet.io/icons/payment/mobikwik.jpg',
    name: 'Mobikwik'
    // },
    // {
    //   wallet: 'JIOMONEY',
    //   icon: 'https://tss-static-images.gumlet.io/icons/payment/jio-money.jpg',
    //   name: 'JioMoney'
    // },
    // {
    //   wallet: 'PAYZAPP',
    //   icon: 'https://tss-static-images.gumlet.io/icons/payment/payzapp.png',
    //   name: 'PayZapp'
    // },
    // {
    //   wallet: 'OXIGEN',
    //   icon: 'https://tss-static-images.gumlet.io/icons/payment/oxigen.png',
    //   name: 'Oxigen'
    // },
    // {
    //   wallet: 'OXIGEN',
    //   icon: 'https://tss-static-images.gumlet.io/icons/payment/oxigen.png',
    //   name: 'Oxigen'
    // },
    // {
    //   wallet: 'OXIGEN',
    //   icon: 'https://tss-static-images.gumlet.io/icons/payment/oxigen.png',
    //   name: 'Oxigen'
  }
]

export class BankInfo {
  static get (num) {
    for (var index in CardBrands) {
      if (num.match(CardBrands[index].regex)) {
        return CardBrands[index]
      }
    }
    return null
  }
}



// WEBPACK FOOTER //
// ./src/components/payment/PaymentConstants.js